import mockData from '../../../features/widget-live-predictions/fixtures/data.json';

export default function* generator() {
    yield mockData;
}
